import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to the top of the page when the route changes.
 * This ensures that when users navigate to a new page, they start at the top
 * instead of maintaining the scroll position from the previous page.
 */
const ScrollToTop = () => {
      const { pathname } = useLocation();

      useEffect(() => {
            window.scrollTo(0, 0);
      }, [pathname]);

      return null;
};

export default ScrollToTop;
